// extracted by mini-css-extract-plugin
export default {"container":"PdfViewer_container__nEDpM","pdfViewerModal":"PdfViewer_pdfViewerModal__aKU8i","page":"PdfViewer_page__2xXVY"};